module.exports = __webpack_public_path__ + "assets/img/discernment_age_scene2.278c92d1.png";